import { formDataRequest, postRequest } from '../libs/AxiosService.util';

export async function serviceCreatePet(params) {
    return await formDataRequest('pets/create', params);
}

export async function serviceUpdatePet(params) {
    return await formDataRequest('pets/update', params);
}

export async function serviceGetPet(params) {
    return await postRequest("pets", params);
}
export async function serviceGetPetProgram(params) {
    return await postRequest("pets/programs", params);
}
export async function servicetPetAssociate(params) {
    return await postRequest("pets/programs/associate", params);
}

export async function servicePetDetail(params) {
    return await postRequest("pets/detail", params);
}
export async function serviceDeletePet(params) {
    return await postRequest("pets/delete", params);
}

export async function servicePetIsExist (params) {  
    return await postRequest('pets/check', params);
}
